import { render } from "./InternFeedbackDatatable.vue?vue&type=template&id=d0fd3df6&scoped=true"
import script from "./InternFeedbackDatatable.vue?vue&type=script&lang=js"
export * from "./InternFeedbackDatatable.vue?vue&type=script&lang=js"

import "./InternFeedbackDatatable.vue?vue&type=style&index=0&id=d0fd3df6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0fd3df6"]])

export default __exports__